<div *ngIf="!history.length" class="no-data">
    No Activity Found.
</div>

<div class="main-frame" *ngIf="history.length">
    <div *ngFor="let rowData of history ; let i = index">
        <div class="row">
            <span class="dhl-type dhl-type-{{rowData['historyTypeText']}}-v2">
                <span class="dhl-type-inner">
                </span>
            </span>
            <span class="label">
                <span class="dhl-type-text-status"> {{rowData['historyType']}} &nbsp; {{rowData['subType']}} </span>
                <span class="dhl-type-text-subLable dateTime"> &nbsp; {{rowData['capturedAt']+'Z' | date : 'MM/dd/yyyy hh:mm:ss a'}}</span>
                <br class="line-height-v2" />
                <span class="dhl-type-text-subLable"> shipment id: {{rowData['shipmentId']}} &nbsp;&nbsp; load id:
                    {{rowData['loadId']}}</span>
            </span>
        </div>

        <div style="padding-bottom: 30px;">

            <!-- <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 col-lg-xl-12">
                <span class="vertical-dashed-line" [ngClass]="{'verticle-line-color' : i == (history.length-1) }">
                </span>
                <span class="col-xs-11 col-sm-11 col-md-11 col-lg-11 col-lg-xl-11">
                    <table class="dhl-table">
                        <thead>
                            <tr class="table-header">
                                <th class="row-color"></th>
                                <th *ngIf="rowData['status']" class="header-data">
                                    <span>STATUS</span>
                                </th>
                                <th class="header-data" *ngFor="let theader of rowData['displayData']; let i = index">
                                    <span>
                                        {{theader.key}}
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-row">
                                <td class="row-color dhl-type-{{rowData['historyTypeText']}}-v2"></td>
                                <td *ngIf="rowData['status']" class="row-data">
                                    <span
                                        class="status-tag-background status-color-{{rowData['status'] | lowercase}}">{{rowData['status']}}</span>
                                </td>
                                <td class="row-data" *ngFor="let theader of rowData['displayData'] ; let i = index">
                                    <span>
                                        {{theader.value}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </span>
            </div> -->

            <div class="row">
                <span class="vertical-dashed-line"
                    [ngClass]="{'verticle-line-color' : i == (history.length-1) }"></span>
                <div class="col-11 row-data dhl-type-{{rowData['historyTypeText']}}-border-v2">
                    <div class="row">
                        <div *ngIf="rowData['status']" class="col-data">
                            <div class="header-data">STATUS</div>
                            <div class="status-tag-background status-color-{{rowData['status'] | lowercase}}">
                                {{rowData['status']}}</div>
                        </div>
                        <div class="col-data" *ngFor="let theader of rowData['displayData']">
                            <div class="header-data">{{theader.key}}</div>
                            <div class="row-data-value">{{theader.value}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>